import { useEffect, useState } from "react";
import { Button, Group, Stack, TextInput } from "@mantine/core";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { cloneRule } from "../../../../../services/rules";
import { getAxiosResponseError } from "../../../../../utils/functions";

/**
 * Clone section of the Details popup. Open the section, enter a new
 * rule name, click Confirm. `onSuccess` runs after cloneRule resolves.
 */
export default function CloneSection({
  ruleId,
  expanded,
  onToggle,
  onSuccess,
}) {
  const { t } = useTranslation();
  const [name, setName] = useState("");

  useEffect(() => {
    if (!expanded) setName("");
  }, [expanded]);

  const mutation = useMutation({
    mutationFn: cloneRule,
    onSuccess: () => {
      toast.success("Rule successfully cloned");
      onSuccess?.();
    },
    onError: (err) => toast.error(getAxiosResponseError(err)),
  });

  return (
    <Stack gap="xs">
      <Group justify="flex-start">
        <Button variant="outline" onClick={onToggle}>
          Clone
        </Button>
      </Group>
      {expanded && (
        <Group align="flex-end" gap="md" wrap="wrap">
          <TextInput
            label={t("multipleSearch.detailsPopup.newRuleName")}
            value={name}
            onChange={(ev) => setName(ev.currentTarget.value)}
            w={240}
          />
          <Button
            disabled={!name}
            loading={mutation.isPending}
            onClick={() => mutation.mutate({ id: ruleId, name })}
          >
            Confirm
          </Button>
        </Group>
      )}
    </Stack>
  );
}
